import type { GetServerSidePropsContext, Redirect } from "next";

/**
 * getServerSideProps的重定向统一处理
 * @example if(isLogout) return serverSideRedirect(res, { destination: "/login", permanent: false });
 */
export function serverSideRedirect(
  res: GetServerSidePropsContext["res"],
  option: Redirect
):
  | {
      redirect: Redirect;
    }
  | {
      props: {};
    } {
  if (res.headersSent) {
    return {
      props: {},
    };
  }
  return {
    redirect: option,
  };
}

export function serverSideNotFound(res: GetServerSidePropsContext["res"]):
  | {
      notFound: true;
    }
  | { props: {} } {
  if (res.headersSent) {
    return {
      props: {},
    };
  }
  return {
    notFound: true,
  };
}
